export interface IUpcomingSwapCalls {
    clusterId: number,
    callInfo: string,
    callType: string,
    swapManager: string,
    swapInfo: string,
    chainId: number,
    clusterNumber: number,
    clusterNote: string,
    swapSize: number,
    swapCourierId: number,
    swapCourierAbbreviation: string,
    swapCourierName: string,
    dialInInfo: string,
    leaderCode: number
}
